module.exports = __webpack_public_path__ + "img/userEquity2.601c1fa3.png";